import type { ClassValue } from 'clsx'

import React from 'react'

import { cn } from '@/lib/utils'

const Container: React.FC<{
  children: React.ReactNode
  className?: ClassValue
}> = ({ children, className }) => {
  return (
    <div className={cn('px-5', className)}>{children}</div>
  )
}

export { Container }